import React from "react";
import {useTranslation} from "react-i18next";

import {BackButton} from "components/BackButton";
import {Layout} from "components/Layout";
import {NewsDetail} from "components/news/NewsDetail";

import "yanaoDiff/pages/SuggestionsPageYanao/modifications.css";

export const NewsDetailPage = () => {
    const {t} = useTranslation("news");

    return (
        <Layout>
            <div className="page">
                <header className="page__header">
                    <BackButton/>
                    <p className="page__title">{t("news_suggestions_title")}</p>
                </header>

                <div className="school-page__wrapper">
                    <NewsDetail/>
                </div>
            </div>
        </Layout>
    );
};
